import type {
  ValidatableValue,
} from "libs/utils/validators/src/lib/validationRules";

export const isFieldPopulated = (value: ValidatableValue): boolean => {
  if (typeof value === "string") {
    return value.trim().length > 0;
  }
  return value !== undefined && value !== null;
};
